(function (Drupal, once) {
  Drupal.behaviors.keidoReadDepth = {
    attach(context) {
      once("keidoReadDepth", "body", context).forEach(() => {
        const thresholds = [25, 50, 75, 100];
        const fired = new Set();

        function getScrollPercent() {
          const scrollTop =
            window.scrollY || document.documentElement.scrollTop;
          const docHeight =
            document.documentElement.scrollHeight - window.innerHeight;

          if (docHeight <= 0) {
            return 100;
          }

          return Math.round((scrollTop / docHeight) * 100);
        }

        function trackDepth() {
          const percent = getScrollPercent();

          thresholds.forEach((threshold) => {
            if (percent >= threshold && !fired.has(threshold)) {
              fired.add(threshold);

              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "page_read_depth",
                scroll_percent: threshold,
                page_path: window.location.pathname,
                page_title: document.title,
              });
            }
          });
        }

        let ticking = false;

        window.addEventListener(
          "scroll",
          () => {
            if (!ticking) {
              window.requestAnimationFrame(() => {
                trackDepth();
                ticking = false;
              });

              ticking = true;
            }
          },
          { passive: true },
        );

        trackDepth();
      });
    },
  };
})(Drupal, once);
